var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"innerbanner",style:(_vm.banner
      ? `background-image: url(${_vm.banner})`
      : `background-image: url(/assets/img/terminal02.jpg)`)})
}
var staticRenderFns = []

export { render, staticRenderFns }